export default "__VITE_ASSET__tLSCeEwJ__"